import { createClient } from '@supabase/supabase-js';

export const supabaseUrl = (import.meta.env.VITE_PUBLIC_SUPABASE_URL as string) || '';
export const supabaseAnonKey =
  (import.meta.env.VITE_PUBLIC_SUPABASE_ANON_KEY as string) || '';

// Singleton Supabase client. Do not create additional client instances elsewhere.
export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
    detectSessionInUrl: true,
  },
});